import {
  FieldDateRange as LookerFieldDateRange,
  type FieldInputDateRangeProps,
} from '@looker/components';

import { cls } from '@/utils/cls';

import style from './styles.module.scss';

export type FieldDateRangeProps = Omit<FieldInputDateRangeProps, 'ref'>;

export function FieldDateRange({ className, ...props }: FieldDateRangeProps) {
  return (
    <div>
      <LookerFieldDateRange
        className={cls(style.fieldDateRange, className)}
        {...props}
      />
    </div>
  );
}
